import { INVITATION_STATUS } from '../../domain/domainCodes.js'
/** Legacy strings for الدعوات — Resources.ar.resx and Admin/Sitemap.ar.resx. */
export const strings = {
  actionDone: 'تمت العملية بنجاح',
  actionFailed: 'تعذر إتمام العملية',
  title: 'الدعوات', // Sitemap.UsersInvitations
  // The legacy view uses the very same resource for the subtitle. Kept as-is.
  subtitle: 'الدعوات', // Sitemap.UsersInvitations
  cardTitle: 'قائمة الدعوات', // Resources.Users_Invitations
  cardHint:
    'تُستخدم الدعوات لدعوة مستخدمين جدد للتسجيل في النظام. هذه الخاصية مخصصة لدعوة الموظفين الذين لا يمتلكون صلاحية الدخول عبر LDAP/Active Directory.\n\nوسيتم إرسال رابط دعوة لهم للتسجيل في المنصة.', // Resources.InvitationsDesc

  actions: {
    newInvitation: 'دعوة جديدة', // Resources.New_Invitation
    manyInvitations: 'إرسال مجموعه دعوات', // Resources.Send_Many_Invitations
  },

  filter: {
    trigger: 'بحث بالحالة', // Resources.Filter_By_Status
    statusLabel: 'الحاله:', // Resources.Status
    statusPlaceholder: 'الحاله',
    adminLabel: 'مدير النظام', // Resources.Admin
    adminPlaceholder: 'لمدير النظام',
    yes: 'نعم', // Resources.Yes
    no: 'لا', // Resources.No
    reset: 'إلغاء', // Resources.Reset
    submit: 'بحث', // Resources.Filter
  },

  columns: {
    email: 'البريد الالكتروني', // Resources.Email_Address
    group: 'الإدارة', // Resources.Department
    createdOn: 'تاريخ الدعوة', // Resources.Created_On
    expiryDate: 'تاريخ إنتهاء الصلاحية', // Resources.Expiry_Date
    status: 'الحاله', // Resources.Status
  },

  stats: {
    caption: 'ملخص الدعوات',
    all: 'كل الدعوات',
  },

  /** LanguageConstants InvitationStatus — SENT=0, USER_REGISTERED=1, CANCELED=2. */
  status: {
    [INVITATION_STATUS.SENT]: 'جديد', // Resources.New
    [INVITATION_STATUS.USER_REGISTERED]: 'تم القبول', // Resources.User_Accepted
    [INVITATION_STATUS.CANCELED]: 'ملغية', // Resources.Canceled
  },

  row: {
    resend: 'إعاده إرسال البريد الإلكتروني', // Resources.Resend_Email
    edit: 'تعديل', // Resources.Edit
    cancel: 'إلغاء الدعوة', // Resources.Cancel_Invitation
    activate: 'تفعيل الدعوة', // Resources.Activate_Invitation
    notifications: 'الإشعارات', // Resources.Notifications
  },

  /** #add_modal — one modal, two mutually exclusive forms. */
  form: {
    singleTitle: 'دعوة مستخدم', // Resources.invite_user — also the title when editing
    bulkTitle: 'دعوة عده مستخدمين', // Resources.invite_many_users
    email: 'البريد الإلكتروني', // Users.EmailLabelResource1_Text
    group: 'الإدارة', // Resources.Department
    expiry: 'تاريخ إنتهاء رابط الدعوة', // Resources.Invitation_Link_Expiry_Date
    expiryPlaceholder: 'تاريخ إنتهاء الصلاحية',
    isAdmin: 'مدير النظام', // Resources.Admin
    save: 'حفظ', // Resources.Save
    send: 'ارسال', // Resources.Send
    emailRequired: 'البريد الإلكتروني مطلوب', // Users.EmailRequiredResource1_ErrorMessage1
    emailInvalid: 'من فضلك قم ادخال بريد الكتروني صحيح', // Users.CreateUserWizardSingleUserResource1_InvalidEmailErrorMessage1
    fileRequired: 'يُرجى رفع ملف بصيغة Excel (.xlsx)',
  },

  /** Shared excel-upload copy — the bulk form accepts xlsx only. */
  excel: {
    intro: 'يُرجى رفع ملف بصيغة Excel (.xlsx)', // Resources.Please_upload_a_file_in_Excel_only
    columnsIntro: 'يجب أن يحتوي الملف على الأعمدة التالية',
    mandatory: 'إجباري', // Resources.Mandatory
    optional: 'إختياري', // Resources.Optional
    notesTitle: 'ملاحظات مهمة', // Resources.Important_Notes
    notes:
      'يجب أن يحتوي الصف الأول في الملف على أسماء الأعمدة، وبنفس الأسماء والترتيب الموضح في الجدول',
    template: 'معاينة القالب', // Resources.ViewTemplate
  },

  resendTitle: 'إعادة إرسال بريد الدعوة؟',
  /* The question moved to the title, so the message can do the one thing a message is for
     here: name the address it is about. Legacy:
     Resources.Are_you_sure_you_want_to_resend_invitation_email_ */
  resendConfirm: 'سيتم إرسال الدعوة مرة أخرى إلى:',
  yes: 'نعم', // Resources.Yes
  no: 'لا', // Resources.No
  close: 'إغلاق', // Users.btnClose
}
